import {BASE_URL} from "../../config/network";
import {getAppliedWhiteLabelThemeId} from "../../config/whiteLabelThemes";

const applyVehicleDetailThemeOverrides = (vehicleDetail) => {
    if (getAppliedWhiteLabelThemeId() !== "privateshare") {
        return vehicleDetail
    }

    return {
        ...vehicleDetail,
        white_label_overrides: {
            ...(vehicleDetail?.white_label_overrides || {}),
            rental_config: "privateshare_daily",
        },
        rental_config: {
            ...(vehicleDetail?.rental_config || {}),
            minimum_rental_time: {
                ...(vehicleDetail?.rental_config?.minimum_rental_time || {}),
                unit: "day",
                value: 1,
            },
            rental_step: 60,
        },
    }
}

const detailVehicleAPI = async ({vehicleId, force = false}) => {
    const CACHE_KEY = `vehicleDetail:${vehicleId}`
    const CACHE_TTL_MS = 5 * 60 * 1000

    const URL = `${BASE_URL}/public/p2p/vehicle/detail/${vehicleId}`
    const METHOD = "GET"
    const HEADERS = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }

    console.log("GET detail vehicle")

    if (!force && typeof window !== 'undefined' && window.localStorage) {
        try {
            const cachedRaw = window.localStorage.getItem(CACHE_KEY)
            if (cachedRaw) {
                const cached = JSON.parse(cachedRaw)
                if (cached?.timestamp && Date.now() - cached.timestamp < CACHE_TTL_MS) {
                    return applyVehicleDetailThemeOverrides(cached.data)
                }
            }
        } catch (error) {
            console.warn("GET detail vehicle cache read error", error)
        }
    }

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS
    })

    if (!response.ok) {
        console.log("GET detail vehicles ERROR")
        throw new Error(`HTTP error: ${response.status}`)
    }

    const data = await response.json()

    if (typeof window !== 'undefined' && window.localStorage) {
        try {
            window.localStorage.setItem(
                CACHE_KEY,
                JSON.stringify({timestamp: Date.now(), data})
            )
        } catch (error) {
            console.warn("GET detail vehicle cache write error", error)
        }
    }

    return applyVehicleDetailThemeOverrides(data)
}

export {detailVehicleAPI}
